// Module
var code = "<component @click.stop.prevent=\"click($event)\" :is=\"rootType\" :href=\"href || false\" class=\"popover-container\" ref=\"popoverEl\" role=\"group\" :aria-label=\"label || false\"> <slot v-bind:isOpen=\"isOpen\"></slot> </component> ";
// Exports
export default code;